import React from 'react';
import { ref_video, food_vintage } from '../../../constants';
import './Intro.css';
import { useTranslation } from 'react-i18next';

const Intro = () => {
  const { t } = useTranslation();

  const handleBookingClick = () => {
    const section = document.querySelector("#booking");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="app__video-container">
      {/* Animated Background Elements */}
      <div className="background-elements">
        <div className="floating-orb orb-1"></div>
        <div className="floating-orb orb-2"></div>
        <div className="floating-orb orb-3"></div>
        <div className="geometric-pattern"></div>
      </div>

      {/* Left video - Wider */}
      <div className="app__video left">
        <div className="video-frame">
          <video
            src={ref_video}
            type="video/mp4"
            loop
            autoPlay
            muted
            playsInline
            preload="auto"
            crossOrigin="anonymous"
            disablePictureInPicture
          />
          <div className="video-overlay-gradient left-gradient"></div>
        </div>
      </div>

      {/* Center Area */}
      <div className="app__center-gradient">
        <div className="premium-backdrop"></div>
        <div className="glass-panel">
          <div className="inner-glow"></div>
        </div>

        <div className="center-content">
          {/* Decorative Elements */}
          <div className="decorative-elements">
            <div className="elegant-border top-border"></div>
            <div className="elegant-border bottom-border"></div>
            <div className="corner-ornament top-left"></div>
            <div className="corner-ornament top-right"></div>
            <div className="corner-ornament bottom-left"></div>
            <div className="corner-ornament bottom-right"></div>
          </div>

          {/* Main Content Area */}
          <div className="main-content">
            {/* Brand Section */}
            <div className="brand-section">
              <div className="brand-icon">
                <div className="chef-hat-icon">
                  <div className="hat-top"></div>
                  <div className="hat-band"></div>
                </div>
              </div>
              <h1 className="brand-title">{t('intro_section.brand_title')}</h1>
              <div className="brand-subtitle">{t('intro_section.brand_subtitle')}</div>
            </div>

            {/* Elegant Divider */}
            <div className="elegant-divider">
              <div className="divider-line left-line"></div>
              <div className="divider-ornament">
                <div className="diamond-shape"></div>
              </div>
              <div className="divider-line right-line"></div>
            </div>

            {/* Features Section */}
            <div className="features-section">
              <div className="feature-item">
                <div className="feature-icon">★</div>
                <span className="feature-text">{t('intro_section.features.premium_cuisine')}</span>
              </div>
              <div className="feature-item">
                <div className="feature-icon">♦</div>
                <span className="feature-text">{t('intro_section.features.exclusive_ambiance')}</span>
              </div>
              <div className="feature-item">
                <div className="feature-icon">✦</div>
                <span className="feature-text">{t('intro_section.features.exceptional_service')}</span>
              </div>
            </div>

            {/* CTA Button */}
            <div className="button-container">
              <div className="button-aura"></div>
              <button className="luxury-button" onClick={handleBookingClick}>
                <span className="button-bg"></span>
                <span className="button-text">
                  <span className="text-primary">{t('intro_section.button_primary')}</span>
                  <span className="text-accent">{t('intro_section.button_accent')}</span>
                </span>
                <div className="button-shine"></div>
                <div className="button-particles">
                  <span className="particle"></span>
                  <span className="particle"></span>
                  <span className="particle"></span>
                  <span className="particle"></span>
                </div>
              </button>
            </div>

            {/* Additional Info */}
            <div className="additional-info">
              <p className="info-text">{t('intro_section.additional_info')}</p>
            </div>
          </div>

          {/* Floating Elements */}
          <div className="floating-elements">
            <div className="floating-star star-1">✦</div>
            <div className="floating-star star-2">★</div>
            <div className="floating-star star-3">✧</div>
            <div className="floating-star star-4">⋆</div>
          </div>
        </div>
      </div>

      {/* Right video */}
      <div className="app__video right">
        <div className="video-frame">
          <video
            src={food_vintage}
            type="video/mp4"
            loop
            autoPlay
            muted
            playsInline
            preload="auto"
            crossOrigin="anonymous"
            disablePictureInPicture
          />
          <div className="video-overlay-gradient right-gradient"></div>
        </div>
      </div>
    </div>
  );
};

export default Intro;
